<template>
  <SfNotification
    v-bind="$attrs"
    v-on="$listeners"
  />
</template>
<script>
import { SfNotification } from '@storefront-ui/vue';
import notifications from '../mixins/notifications';

export default {
  name: 'Notification',
  mixins: [notifications],
  created() {
    if (this.$attrs.visible) {
      setTimeout(() => {
        this.hideNotification(this.$attrs.index);
      }, 5000);
    }
  },
  components: {
    SfNotification,
  },
};
</script>
<style lang="scss" scoped>
.sf-notification {
  --notification-max-width: 100%;
}

.sf-notification + .sf-notification {
  margin-top: 5px;
}
</style>
